
import { defineComponent } from "vue";
import SearchInfo from "./SearchInfo.vue";
import CartIcon from "./CartIcon.vue";
export default defineComponent({
  components: { SearchInfo, CartIcon },
  setup() {},
});
